/**
 * Event Tracking Component
 *
 * @author Steph Ritchie <sritchie@wayfair.com>
 * @copyright 2018 Wayfair LLC - All rights reserved
 */
/* eslint-disable @wayfair/wf-rules/check-prettier */
import React from 'react';
import compose from 'lodash.flowright';
import PropTypes from 'prop-types';

const noop = () => {};

const TrackEvent = props => {
  const {
    tracker: {track, eventTypes},
  } = props;
  // verify that there is a single child
  const element = React.Children.only(props.children);

  const handlers = Object.entries(props.events).reduce((acc, [key, value]) => {
    // Create a composite function of original event handler and track handler.
    const handler = compose(
      result => {
        track(
          {
            eventType:
              eventTypes[value.type] || value.type || eventTypes.action,
            actionName: value.name,
            ...props.data,
          },
          {once: props.once}
        );
        return result;
      },
      props.children.props[key] || noop
    );

    return {...acc, [key]: handler};
  }, {});

  return React.cloneElement(element, {...element.props, ...handlers});
};

TrackEvent.propTypes = {
  tracker: PropTypes.object.isRequired,
  events: PropTypes.object.isRequired,
  data: PropTypes.object,
  children: PropTypes.node.isRequired,
  once: PropTypes.bool,
};

TrackEvent.defaultProps = {
  once: false,
  data: {},
};

export default TrackEvent;
